﻿import { SaveButton } from "../../../../Fundraising.UI.Shared/Modules/formTools/SaveButton";
import "../scss/login.scss";

(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.Login = {};

    let loginBtn;

    const setSubmitBtn = () => {
        const $submitBtn = $("#account-login");

        loginBtn = new SaveButton("#account-login", {
            "savingLabel": $submitBtn.data("saving-label"),
            "savedLabel": $submitBtn.data("saved-label")
        });
    }

    function setInitialLogin() {
        $(document).on("click", ".administrator-chooser .choice.administrator .btn", function (e) {
            e.preventDefault();
            $(".administrator-chooser").slideUp();
            $(".login-form").hide().removeClass("hidden").slideDown();
        });

        $(document).on("click", ".login-form .reset-login", function (e) {
            e.preventDefault();
            $(".login-form").removeClass("hidden").slideUp();
            $(".administrator-chooser").hide().removeClass("hidden").slideDown();
        });
    }

    M2.Login = {
        init: function () {
            setInitialLogin();
            setSubmitBtn();
        }
    }
})(jQuery);

$(function () {
    M2.Login.init();
});